// teachingmode.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../services/api';
import './teachingmode.css';
import { useLanguage } from '../contexts/languagecontext';
import HamburgerMenu from '../components/navigation/hamburgermenu';
import CustomSelect from '../components/CustomSelect';

function TeachingMode() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Navigation state
  const [currentStep, setCurrentStep] = useState('subjects'); // subjects, chapters, topics, subtopics, chunks
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedSubtopic, setSelectedSubtopic] = useState(null);
  
  // Data state
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  //const [topics, setTopics] = useState([]);
  //const [subtopics, setSubtopics] = useState([]);
  //const [chunks, setChunks] = useState([]);
  
  // UI state
  const [loading, setLoading] = useState(false);
  const { currentLanguage, switchLanguage } = useLanguage();

  useEffect(() => {
    // Check if returning from topics interface
    if (location.state?.returnToChapters) {
      const { selectedSubject: prevSubject } = location.state;
      
      // Restore previous state
      setSelectedSubject(prevSubject);
      setCurrentStep('chapters');
      loadChapters(prevSubject.subject_id);
    }
    // Check if returning from learning session (REDUNDANT - will be removed)
    else if (location.state?.returnToChunks) {
      const { selectedSubject: prevSubject, selectedChapter: prevChapter, 
              selectedTopic: prevTopic, selectedSubtopic: prevSubtopic } = location.state;
      
      // Restore previous state
      setSelectedSubject(prevSubject);
      setSelectedChapter(prevChapter);
      setSelectedTopic(prevTopic);
      setSelectedSubtopic(prevSubtopic);
      setCurrentStep('chunks');
      
      // Load chunks directly here instead of using loadChunks function
      // const loadChunksForReturn = async () => {
      //   setLoading(true);
      //   try {
      //     const params = new URLSearchParams({
      //       subject_id: prevSubject.subject_id,
      //       chapter_id: prevChapter.chapter_id,
      //       topic_id: prevTopic.topic_id
      //     });
          
      //     if (prevSubtopic) {
      //     params.append('subtopic_id', prevSubtopic.subtopic_id);
      //     }
      //     const response = await fetch(`http://80.225.197.31:8000/chunks/?${params}`);
      //     if (response.ok) {
      //       const chunksData = await response.json();
      //       setChunks(chunksData);
      //     }
      //   } catch (error) {
      //   console.error('Failed to load chunks:', error);
      //   setChunks([]);
      //   }
      //   setLoading(false);
      // };
      // loadChunksForReturn();
    } else {
      loadSubjects();
    }
  }, [location.state]);          
      

  const loadSubjects = async () => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const studentId = userData?.student?.student_id;
      const subjectsData = await ApiService.getSubjects(studentId);
      setSubjects(subjectsData);
    } catch (error) {
      console.error('Failed to load subjects:', error);
    }
    setLoading(false);
  };

  const loadChapters = async (subjectId) => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const studentId = userData?.student?.student_id;
      const chaptersData = await ApiService.getChapters(subjectId, studentId);
      setChapters(chaptersData);
    } catch (error) {
      console.error('Failed to load chapters:', error);
    }
    setLoading(false);
  };

  // const loadTopics = async (chapterId, subjectId) => {
  //   setLoading(true);
  //   try {
  //     const topicsData = await ApiService.getTopics(chapterId, subjectId);
  //     setTopics(topicsData);
  //   } catch (error) {
  //     console.error('Failed to load topics:', error);
  //   }
  //   setLoading(false);
  // };

  // const loadSubtopics = async (topicId) => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(`http://80.225.197.31:8000/subtopics/?topic_id=${topicId}`);
  //     if (!response.ok) throw new Error('Failed to fetch subtopics');
  //     const subtopicsData = await response.json();
  //     setSubtopics(subtopicsData);
  //   } catch (error) {
  //     console.error('Failed to load subtopics:', error);
  //     setSubtopics([]); // No subtopics available
  //   }
  //   setLoading(false);
  // };

  // const loadChunks = async (subtopicId = null) => {
  //   setLoading(true);
  //   try {
  //     const params = new URLSearchParams({
  //       subject_id: selectedSubject.subject_id,
  //       chapter_id: selectedChapter.chapter_id,
  //       topic_id: selectedTopic.topic_id
  //     });
      
  //     // Add subtopic_id if we have one
  //     const currentSubtopicId = subtopicId !== null ? subtopicId : selectedSubtopic?.subtopic_id;
  //     if (currentSubtopicId) {
  //       params.append('subtopic_id', currentSubtopicId);
  //     }
      
  //     console.log('Loading chunks with params:', params.toString()); // Debug log
      
  //     const response = await fetch(`http://80.225.197.31:8000/chunks/?${params}`);
  //     if (!response.ok) {
  //       const errorText = await response.text();
  //       console.error('Chunks API error:', response.status, errorText);
  //       throw new Error(`Failed to fetch chunks: ${response.status}`);
  //     }
      
  //     const chunksData = await response.json();
  //     console.log('Loaded chunks:', chunksData); // Debug log
  //     setChunks(chunksData);
      
  //     if (chunksData.length === 0) {
  //       console.warn('No chunks found for the selected topic/subtopic');
  //     }
  //   } catch (error) {
  //     console.error('Failed to load chunks:', error);
  //     setChunks([]); // Set empty array on error
  //   }
  //   setLoading(false);
  // };

  const handleSubjectSelect = (subject) => {
    setSelectedSubject(subject);
    setSelectedChapter(null);
    setSelectedTopic(null);
    setSelectedSubtopic(null);
    loadChapters(subject.subject_id);
    setCurrentStep('chapters');
  };

  const handleChapterSelect = (chapter) => {
    navigate('/topics-subtopics', {
      state: {
        selectedSubject,
        selectedChapter: chapter,
        language: currentLanguage
      }
    });
  };

  // const handleTopicSelect = async (topic) => {
  //   setSelectedTopic(topic);
  //   setSelectedSubtopic(null);
  //   setChunks([]); // Clear existing chunks
  //   await loadSubtopics(topic.topic_id);
    
  //   // If no subtopics, go directly to chunks
  //   const subtopicsResponse = await fetch(`http://80.225.197.31:8000/subtopics/?topic_id=${topic.topic_id}`);
  //   const subtopicsData = subtopicsResponse.ok ? await subtopicsResponse.json() : [];
    
  //   if (subtopicsData.length === 0) {
  //     await loadChunks(null);
  //     setCurrentStep('chunks');
  //   } else {
  //     setCurrentStep('subtopics');
  //   }
  // };

  // const handleSubtopicSelect = async (subtopic) => {
  //   // Navigate directly to enhanced chunks instead of loading chunks
  //   navigate('/enhanced-chunks', {
  //     state: {
  //       selectedSubject,
  //       selectedChapter,
  //       selectedTopic,
  //       selectedSubtopic: subtopic,
  //       language: currentLanguage
  //     }
  //   });
  // };

  // const handleSkipSubtopics = async () => {
  //   // Navigate directly to enhanced chunks without subtopic
  //   navigate('/enhanced-chunks', {
  //     state: {
  //       selectedSubject,
  //       selectedChapter,
  //       selectedTopic,
  //       selectedSubtopic: null,
  //       language: currentLanguage
  //     }
  //   });
  // };

  // const handleChunkSelect = (chunk) => {
  //   // Navigate to enhanced chunks with all required data
  //   navigate('/enhanced-chunks', {  
  //     state: {
  //       chunk,
  //       selectedSubject,
  //       selectedChapter,
  //       selectedTopic,
  //       selectedSubtopic,
  //       language: currentLanguage
  //     }
  //   });
  // };

  const handleBack = () => {
    switch (currentStep) {
      case 'chapters':
        setCurrentStep('subjects');
        setSelectedSubject(null);
        setChapters([]);
        // Ensure subjects are loaded when returning to subjects page
        loadSubjects();
        break;
      // case 'topics':
      //   setCurrentStep('chapters');
      //   setSelectedChapter(null);
      //   setTopics([]);
      //   loadChapters(selectedSubject.subject_id); // Reload chapters
      //   break;
      // case 'subtopics':
      //   setCurrentStep('topics');
      //   setSelectedTopic(null);
      //   setSubtopics([]);
      //   loadTopics(selectedChapter.chapter_id, selectedSubject.subject_id); // Reload topics
      //   break;
      // case 'chunks':
      //   if (selectedSubtopic || subtopics.length === 0) {
      //     if (subtopics.length === 0) {
      //       setCurrentStep('topics');
      //       setSelectedTopic(null);
      //       setTopics([]);
      //       loadTopics(selectedChapter.chapter_id, selectedSubject.subject_id);
      //     } else {
      //       setCurrentStep('subtopics');
      //       setSelectedSubtopic(null);
      //       // Subtopics should already be loaded
      //     }
      //   } else {
      //     setCurrentStep('subtopics');
      //   }
      //   setChunks([]);
      //   break;
      default:
        break;
    }
  };

  const renderBreadcrumb = () => {
    const items = [];
    
    if (selectedSubject) items.push(selectedSubject.name);
    if (selectedChapter) items.push(selectedChapter.name);
    if (selectedTopic) items.push(selectedTopic.name);
    if (selectedSubtopic) items.push(selectedSubtopic.name);
    
    return (
      <div className="breadcrumb">
        {/* <span className="breadcrumb-home">🏠</span> */}
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="breadcrumb-arrow">›</span>}
            {/* <span className="breadcrumb-arrow">›</span> */}
            <span className="breadcrumb-item">{item}</span>
          </React.Fragment>
        ))}
      </div>
    );
  };

  const renderSubjects = () => (
    <div className="selection-container">
      <div className="selection-header">
        <h2>📚 Choose Your Subject</h2>
        <p>Select a subject to start your learning journey</p>
        
        {/* Language Selection at Subject Level */}
        <div className="language-selection-main">
          <h4>🌐 Choose Learning Language:</h4>
          <div className="language-options">
            <button 
              className={`language-option ${currentLanguage === 'en' ? 'active' : ''}`}
              onClick={() => switchLanguage('en')}
            >
              🇺🇸 English
            </button>
            <button 
              className={`language-option ${currentLanguage === 'hi' ? 'active' : ''}`}
              onClick={() => switchLanguage('hi')}
            >
              🇮🇳 Hindi
            </button>
          </div>
          
        </div>
      </div>
      
      <div className="cards-grid">
        {subjects.filter(subject => {
          const studentData = JSON.parse(localStorage.getItem('userData') || '{}');
          const accessibleSubjects = studentData.student?.accessible_subjects || [];
          return accessibleSubjects.some(accSubj => accSubj.subject_id === subject.subject_id);
        }).map((subject) => (
          <div
            key={subject.subject_id}
            className="selection-card subject-card"
            onClick={() => handleSubjectSelect(subject)}
          >
            {/* <div className="card-icon">📖</div> */}
            <h3>{subject.name}</h3>
            <p>{subject.description || 'Explore this subject'}</p>
            <div className="card-hover-effect"></div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderChapters = () => (
    <div className="selection-container">
      <div className="selection-header">
        <h2>📑 Select Chapter</h2>
        <p>Choose a chapter from <strong>{selectedSubject.name}</strong></p>
      </div>
      
      <div className="cards-grid">
        {chapters.map((chapter) => (
          <div 
            key={chapter.chapter_id} 
            className="selection-card chapter-card"
            onClick={() => handleChapterSelect(chapter)}
          >
            {/* <div className="card-icon">📄</div> */}
            <h3>{chapter.name}</h3>
            <p>{chapter.description || 'Start learning this chapter'}</p>
            <div className="card-hover-effect"></div>
          </div>
        ))}
      </div>
    </div>
  );

  // const renderTopics = () => (
  //   <div className="selection-container">
  //     <div className="selection-header">
  //       <h2>🎯 Pick Your Topic</h2>
  //       <p>Choose a topic from <strong>{selectedChapter.name}</strong></p>
  //     </div>
      
  //     <div className="cards-grid">
  //       {topics.map((topic) => (
  //         <div 
  //           key={topic.topic_id} 
  //           className="selection-card topic-card"
  //           onClick={() => handleTopicSelect(topic)}
  //         >
  //           <div className="card-icon">🎯</div>
  //           <h3>{topic.name}</h3>
  //           <p>{topic.description || 'Dive into this topic'}</p>
  //           <div className="card-hover-effect"></div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

  // const renderSubtopics = () => (
  //   <div className="selection-container">
  //     <div className="selection-header">
  //       <h2>🔍 Choose Subtopic</h2>
  //       <p>Choose a subtopic from <strong>{selectedTopic.name}</strong></p>
  //       <button 
  //         className="skip-button"
  //         onClick={handleSkipSubtopics}
  //       >
  //         Skip to All Chunks
  //       </button>
  //     </div>
      
  //     <div className="cards-grid">
  //       {subtopics.map((subtopic) => (
  //         <div 
  //           key={subtopic.subtopic_id} 
  //           className="selection-card subtopic-card"
  //           onClick={() => handleSubtopicSelect(subtopic)}
  //         >
  //           <div className="card-icon">🔸</div>
  //           <h3>{subtopic.name}</h3>
  //           <p>{subtopic.description || 'Focus on this subtopic'}</p>
  //           <div className="card-hover-effect"></div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

  // const renderChunks = () => (
  //   <div className="selection-container">
  //     <div className="selection-header">
  //       <h2>📦 Select Learning Chunk</h2>
  //       <p>Choose a chunk to start learning step by step</p>
  //       {chunks.length === 0 && !loading && (
  //         <p style={{color: '#ff6b6b', marginTop: '1rem'}}>
  //           ⚠️ No chunks found for this topic. Please contact admin to add content.
  //         </p>
  //       )}
  //     </div>
      
  //     {chunks.length > 0 ? (
  //       <div className="chunks-grid">
  //         {chunks.map((chunk, index) => (
  //           <div 
  //             key={chunk.chunk_id} 
  //             className="chunk-card"
  //             onClick={() => handleChunkSelect(chunk)}
  //           >
  //             <div className="chunk-header">
  //               <span className="chunk-number">{index + 1}</span>
  //               <span className="chunk-type">📚 Chunk</span>
  //             </div>
  //             <div className="chunk-content">
  //               <h3>{chunk.chunk_title || `Chunk ${index + 1}`}</h3>
  //               <p className="chunk-preview">
  //                 {chunk.chunk_text?.substring(0, 120)}...
  //               </p>
  //               <div className="chunk-meta">
  //                 <span className="micro-chunk-count">
  //                   🔹 {chunk.micro_chunk_count || 'Multiple'} micro-chunks
  //                 </span>
  //               </div>
  //             </div>
  //             <div className="chunk-action">
  //               <span className="start-learning">Start Learning →</span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     ) : null}
  //   </div>
  // );

  return (
    <div className="teaching-mode">
      {/* Hamburger Menu */}
      {/* <HamburgerMenu /> */}
      {/* Header Section */}
      <div className="teaching-header">
        <div className="header-content">
          {/* Row 1: Teaching Mode + Language Dropdown */}
          <div className="header-row">
            <div className="header-left">
              <h1>🎓 Teaching Mode</h1>
            </div>
            <div className="header-right">
              <div className="language-selector">
                <CustomSelect
                  value={currentLanguage}
                  onChange={(e) => switchLanguage(e.target.value)}
                  options={[
                    { value: 'en', label: '🇺🇸 English' },
                    { value: 'hi', label: '🇮🇳 Hindi' }
                  ]}
                  placeholder="Select Language"
                />
              </div>
            </div>
          </div>

          {/* Row 2: Subject Name + Back Button (only show when not on subjects page) */}
          {currentStep !== 'subjects' && (
            <div className="header-row">
              <div className="breadcrumb">
                {renderBreadcrumb()}
              </div>
              <div className="header-right">
                <button className="back-button" onClick={handleBack}>
                  ← Back
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="teaching-content">
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        )}

        {!loading && (
          <>
            {currentStep === 'subjects' && renderSubjects()}
            {currentStep === 'chapters' && renderChapters()}
            {/* {currentStep === 'topics' && renderTopics()}
            {currentStep === 'subtopics' && renderSubtopics()}
            {currentStep === 'chunks' && renderChunks()} */}
          </>
        )}
      </div>
    </div>
  );
}

export default TeachingMode;